import * as React from "react"
import type { IconProps } from "../types"

const FolderUpload = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", size = 24, ...props }, ref) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        ref={ref}
        viewBox="0 0 24 24"
        {...props}
      >
        <path
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M16 19H20C20.5523 19 21 18.5523 21 18V8C21 7.44772 20.5523 7 20 7H12.5352C12.2008 7 11.8886 6.8329 11.7031 6.5547L10.2969 4.4453C10.1114 4.1671 9.79917 4 9.46482 4H4C3.44772 4 3 4.44772 3 5V18C3 18.5523 3.44772 19 4 19H8M12 19V13M12 13L14.5 15.5M12 13L9.5 15.5"
        />
      </svg>
    )
  }
)
FolderUpload.displayName = "FolderUpload"

export default FolderUpload
